import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/svg/commissionPercent/scheme-m-l.svg'
import _imports_1 from '@/assets/svg/commissionPercent/scheme-s.svg'
import _imports_2 from '@/assets/svg/dots-circle.svg'
import _imports_3 from '@/assets/svg/commissionPercent/background.svg'


const _hoisted_1 = {
  class: "commission-wrapper",
  id: "commission"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"container-m-l\"><div class=\"caps-text mx-3\">Каждый процент комиссии</div><div class=\"caps-text mx-3\">важен для бизнеса</div></div><div class=\"container-s\"><div class=\"caps-text mx-3\">Каждый процент комиссии важен для бизнеса</div></div><div class=\"d-flex justify-content-center\"><img class=\"img-commission-scheme-m-l\" src=\"" + _imports_0 + "\"><img class=\"img-commission-scheme-s\" src=\"" + _imports_1 + "\"></div><div class=\"d-flex justify-content-center position-relative\"><img class=\"img-commission-dots-circle\" src=\"" + _imports_2 + "\"><img class=\"img-commission-background\" src=\"" + _imports_3 + "\"><div class=\"commission_text\">Работая с нами, вы экономите до 5.3% - 53 000 рублей прибыли с каждого 1 000 000 рублей выручки</div></div>", 4)
const _hoisted_6 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_6))
}